import axios from "axios";

const api = axios.create({
  baseURL: "https://api.augdev.fr//wp-json/wp/v2",
});

export default api;